import { canAccessLocationRoles, isSpaceAdmin } from 'app/reducers/role'

export const getEditRole = (user, loc_id) => {
  return canAccessLocationRoles(user, loc_id, ['admin', 'boss', 'manager', 'location_group_operator', 'location_group_manager', 'location_group_wechat_manager', 'location_manager']) || isSpaceAdmin(user)
}
